import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Products from "../Products/Products.jsx";
import styles from "../Home/Home.module.css";

const testimonialImages = [
  { src: "/testimonials/IMG_3125.jpeg", alt: "Доволен клиент" },
  { src: "/testimonials/IMG_3464.png", alt: "Доволен клиент" },
  { src: "/testimonials/IMG_3639.png", alt: "Доволен клиент" },
  { src: "/testimonials/IMG_3652.png", alt: "Доволен клиент" },
  { src: "/testimonials/IMG_3661.png", alt: "Доволен клиент" },
];

const Home = () => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  const prev = () => setCurrentIndex(i => (i - 1 + testimonialImages.length) % testimonialImages.length);
  const next = () => setCurrentIndex(i => (i + 1) % testimonialImages.length);

  const touchStartX = React.useRef(null);
  const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) diff > 0 ? next() : prev();
    touchStartX.current = null;
  };

  useEffect(() => {
    const adjustPadding = () => {
      const homeContainer = document.querySelector(`.${styles.homeContainer}`);
      if (!homeContainer) return;

      const headerOffset = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue("--header-offset")
      ) || 0;

      homeContainer.style.paddingTop = `${headerOffset + 20}px`;
    };

    adjustPadding();
    window.addEventListener("resize", adjustPadding);

    return () => {
      window.removeEventListener("resize", adjustPadding);
    };
  }, []);

  const handleNavigate = () => {
    navigate("/products");
  };

  return (
    <div className={styles.homeContainer}>
      <div className={styles.hero}>
        <p className={styles.eyebrow}>Нова селекция Luminis</p>
        <h1 className={styles.title}>Перлата е винаги на мода.</h1>
        <p className={styles.subtitle}>
          Колие с перла в мида и подаръчни продукти, готови да зарадват любим човек.
        </p>
        <div className={styles.ctaRow}>
          <button className={styles.actionButton} onClick={handleNavigate}>
            Виж колекциите
          </button>
        </div>
        {/* <div className={styles.pillGroup}>
          <span className={styles.pill}>Перла в истинска мида</span>
          <span className={styles.pill}>Подаръчни продукти</span>
          <span className={styles.pill}>Доставка до 3 работни дни</span>
        </div> */}
      </div>

      <div className={styles.productsSection}>
        <div className={styles.sectionHeading}>
          <h2>Топ подаръци</h2>
          <p>Най-желаните ни продукти</p>
        </div>
        <Products showTitle={false} />
      </div>

      <div className={styles.testimonialsSection}>
        <div className={styles.sectionHeading}>
          <h2>Доволни клиенти</h2>
          <p>Реални отзиви от наши клиенти</p>
        </div>
        {testimonialImages.length > 0 ? (
          <div className={styles.carouselWrapper}>
            <div className={styles.carouselCard} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
              <img
                src={testimonialImages[currentIndex].src}
                alt={testimonialImages[currentIndex].alt}
                className={styles.carouselImage}
              />
            </div>
            <div className={styles.carouselControls}>
              <button className={styles.carouselArrow} onClick={prev} aria-label="Предишна">&#8249;</button>
              <div className={styles.carouselDots}>
                {testimonialImages.map((_, i) => (
                  <button
                    key={i}
                    className={i === currentIndex ? styles.dotActive : styles.dot}
                    onClick={() => setCurrentIndex(i)}
                    aria-label={`Снимка ${i + 1}`}
                  />
                ))}
              </div>
              <button className={styles.carouselArrow} onClick={next} aria-label="Следваща">&#8250;</button>
            </div>
          </div>
        ) : (
          <div className={styles.testimonialsEmpty}>
            <p>Снимките ще се появят тук след като бъдат добавени.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
